<span class="phone-and-pin badge rounded-pill">
    <span class="phone-and-pin__label">CALL:</span>
    <span class="phone-and-pin__data pe-3">{{phone}}</span>

    <span class="phone-and-pin__label">PIN:</span>
    <span class="phone-and-pin__data"> {{pin}}</span>
</span>

